import script from "./ParentStudentDashboard.vue?vue&type=script&setup=true&lang=js"
export * from "./ParentStudentDashboard.vue?vue&type=script&setup=true&lang=js"

import "./ParentStudentDashboard.vue?vue&type=style&index=0&id=1d7c86ba&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\lms-alternates\\vue-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1d7c86ba"]])

export default __exports__